import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, IonFooter } from '@ionic/react'
import { MktAmountBoard, PayModal, McGiveDetail, DetailModal, MyCardItem, CardEquityModal } from '@cps'
import { modalLayer, useHistoryNew, getCouponsInfo, toast } from '@utils'
import { memberMobx, virtualOrderMobx, authConfigMobx } from '@mobxStore'
import { keyBy } from '@dt/fe-utils/dist/lodash'
import mktController from 'controllers/mktController'
import { format, toPrice } from '@dt/fe-utils'
import ActivityApi from '@api/activity.api'
import i18n from 'i18next'
import { TermsTick, ChooseStore, StoreListModal, MktHeader } from 'pages/mkt/components'
import { cartMobx, storeMobx, restaurantConfig } from 'restaurant'
import './index.scss'

interface IProps extends IPage, RouteComponentProps {}

const Recharge: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { cardId } = match.params as any
  const eatType = cartMobx.info.eatType
  const channel = cartMobx.channel
  const { getMemberCardDetail, brandConfig } = memberMobx
  // Component State
  const [cardInfo, setCardInfo] = useState<any>(null)
  const [showAmountModal, setShowAmountModal] = useState<boolean>(false)
  const [couponMap, setCouponMap] = useState<any>({})
  const [showPopover, setShowPopover] = useState<boolean>(false)
  const [isAgree, setIsAgree] = useState<boolean>(false)
  const [showTip, setShowTip] = useState<boolean>(false)
  const [scaleArr, setScaleArr] = useState<any>([])
  const [clause, setClause] = useState<IClauseInfo>(null)
  const [storeInfo, setStoreInfo] = useState<IStoreInfo>({ storeId: 0, storeName: '' })
  // Component Event
  const changeCustom = (val: number) => {
    setShowAmountModal(false)
    handleBuy({
      money: val,
      moneyGive: 0,
      storeId: storeInfo.storeId
    })
  }
  const checkRule = () => {
    if (brandConfig.memberCardCzSetting && !brandConfig.memberCardCzSetting.channels.includes('mobile')) {
      toast({ message: i18n.t('mkt.member.notRechargeTip') })
      return false
    }
    if (!isAgree && clause?.clauseName) {
      setShowTip(true)
      return false
    }
    return true
  }
  const handleAdd = (item: any) => {
    if (cardInfo.card?.status === 'disable' || cardInfo.status === 'disable') {
      toast({ message: i18n.t('mkt.member.cardDisableTip') })
      return
    }
    if (!checkRule()) return
    if (brandConfig?.isSelectStoreWhenCz && !storeInfo.storeId) {
      modalLayer(StoreListModal, { showIds: cardInfo.card?.isAllStore ? null : cardInfo.card?.storeIds }, 'StoreListModal').then((val: any) => {
        setStoreInfo({ storeId: val.storeId, storeName: val.storeName })
        handleBuy({
          money: item.money,
          moneyGive: item.moneyGive,
          cardRechargeId: item.cardRechargeId,
          storeId: val.storeId
        })
      }).catch(() => { })
    } else {
      handleBuy({
        money: item.money,
        moneyGive: item.moneyGive,
        cardRechargeId: item.cardRechargeId,
        storeId: brandConfig?.isSelectStoreWhenCz ? storeInfo.storeId : 0
      })
    }
  }
  const changeTermsStatus = (status: boolean) => {
    if (status) setShowTip(false)
    setIsAgree(status)
  }
  const showGive = (item: any, cnt: number) => {
    if (!cnt) return
    modalLayer(McGiveDetail, { info: item, couponMap, cnt }, 'giveDetail')
  }
  const showCardEquity = (type: 'equity' | 'store' | 'integral' | 'recharge') => {
    modalLayer(CardEquityModal, { cardInfo, type }).then(() => { }, () => { })
  }

  let posting = false
  const handleBuy = async (obj: any) => {
    if (posting) return
    if (cardInfo?.card?.extra?.needBindMobile && !memberMobx?.memberInfo?.mobile) {
      mktController.jumpBind(history, 'all')
      return
    }
    posting = true
    const orderParams = virtualOrderMobx.getMcRechargeOrder({
      cardNo: cardInfo.cardNo,
      cardName: cardInfo.card?.cardName,
      mobilePayBackJumb: history.getPrevState() === '/checkout' ? JSON.stringify({ path: '/checkout', storeId: storeMobx.info.storeId, eatType, channel, codeType: restaurantConfig.codeType }) : ''
    }, obj)
    try {
      modalLayer(PayModal, { scene: 'giftcard_buy', orderPara: orderParams, history })
    } catch (error) {
      console.error('充值报错 ====> ', error)
    }
    posting = false
  }
  // Component Effect
  useEffect(() => {
    getMemberCardDetail({
      memberCardId: cardId,
    }).then((res: any) => {
      if (res) setCardInfo(res)
      const arr: any = []
      if (res?.card?.allowAgainLoad && res?.card?.recharges?.length > 0) {
        let list: any = []
        res.card.recharges.map((item: any) => {
          if (item.coupons.length > 0) list = list.concat(item.coupons)
          arr.push({
            ...item,
            type: 'fixed'
          })
        })
        if (list.length > 0) {
          ActivityApi.getCouponsList({
            couponIds: getCouponsInfo(list)
          }).then((res: any) => {
            if (!res.error) {
              setCouponMap(keyBy(res, 'couponId'))
            }
          })
        }
      }
      if (res.card?.allowCustomizeLoad) {
        arr.push({
          type: 'custom',
          maxLoad: res.card.maxLoad,
          minLoad: res.card.minLoad,
        })
      }
      setScaleArr(arr)
    })
  }, [cardId])
  useEffect(() => {
    if (memberMobx.brandConfig?.clauses?.memberCz?.status === 'enable') {
      setClause(memberMobx.brandConfig.clauses.memberCz)
      setIsAgree(memberMobx.brandConfig.clauses.memberCz.isDefaultCheck)
    }
  }, [brandConfig])

  return (
    <IonPage
      className='card-recharge-page'
    >
      <MktHeader onBack={() => mktController.goBack(history)} title={`${i18n.t('mkt.record.memberCz')} ${brandConfig?.isSelectStoreWhenCz ? '' : i18n.t('mkt.giftCard.onlineRecharge')}`}></MktHeader>
      <IonContent className='page-content'>
        {
          cardInfo &&
            <div className='card-block'>
              <MyCardItem cardInfo={cardInfo} isOperate={false} />
              {
                brandConfig?.isSelectStoreWhenCz &&
                  <div className='card-block-store' style={{ backgroundColor: cardInfo.card?.extra.btnColor || '#B8B8B8 ', color: cardInfo.card?.extra.btnFontColor || '#251E1E' }}><span>{i18n.t('mkt.member.rechangeStore')}:</span><ChooseStore scene='cardRecharge' openChoose={!!brandConfig?.isSelectStoreWhenCz} detailInfo={cardInfo.card} storeInfo={storeInfo} onChange={(info: any) => setStoreInfo(info)}></ChooseStore></div>
              }
            </div>
        }
        <div className='recharge-block'>
          {
            scaleArr.map((item: any, index: number) => {
              if (item.type === 'custom') {
                return (
                  <div key={index} className='recharge-item-block'>
                    <div className='price'>{format.toCurrency()}<span>{i18n.t('newCart.auto')}</span></div>
                    <div className='recharge-desc'></div>
                    <div
                      className='recharge-btn'
                      onClick={() => {
                        if (cardInfo.card?.status === 'disable' || cardInfo.status === 'disable') {
                          toast({ message: i18n.t('mkt.member.cardDisableTip') })
                          return
                        }
                        if (!checkRule()) return
                        if (brandConfig?.isSelectStoreWhenCz && !storeInfo.storeId) {
                          modalLayer(StoreListModal, { showIds: cardInfo.card?.isAllStore ? null : cardInfo.card?.storeIds }, 'StoreListModal').then((val: any) => {
                            setStoreInfo({ storeId: val.storeId, storeName: val.storeName })
                            setShowAmountModal(true)
                          }).catch(() => { })
                        } else {
                          setShowAmountModal(true)
                        }
                      }}
                    >{i18n.t('mkt.member.rechargeBalance')}
                    </div>
                  </div>
                )
              } else {
                const cnt = getCouponsInfo(item.coupons, 'cnt', couponMap)
                let des = item.moneyGive > 0 ? `${i18n.t('mkt.giftCard.giveAway')} ${format.toPriceNoCurrency(item.moneyGive, -1)}` : ''
                if (authConfigMobx.isNoWorry) {
                  des = item.moneyGive > 0 ? `${i18n.t('mkt.giftCard.giveAway')} ${toPrice(item.moneyGive)} ` : ''
                  if (cnt > 0) {
                    let couponName = []
                    item.coupons.forEach((info: any) => {
                      if (couponMap[info.couponId]) {
                        if (info.couponCnt > 1) {
                          couponName.push(`${couponMap[info.couponId].couponName}*${info.couponCnt}`)
                        } else {
                          couponName.push(couponMap[info.couponId].couponName)
                        }
                      }
                    })
                    des = des ? des + `${i18n.t('mkt.common.and')} ` + couponName.join(',') : `${i18n.t('mkt.giftCard.giveAway')}${couponName.join(',')}`
                  }
                } else {
                  des = item.moneyGive > 0 && cnt > 0 ? des + ', ' : des
                  des = cnt > 0 ? des + i18n.t('mkt.coupon.giveCouponNumber', { number: cnt }) : des
                }
                return (
                  <div key={index} className='recharge-item-block'>
                    {!!item?.ifRecommend && <div className='recharge-reco'>{i18n.t('mkt.giftCard.recommend')}</div>}
                    <div className='price'>{format.toPrice(item.money, 2)}</div>
                    <div className='recharge-desc' onClick={() => showGive(item, cnt)}>{des}</div>
                    <div className='recharge-btn' onClick={() => handleAdd(item)}>{i18n.t('mkt.member.rechargeBalance')}</div>
                  </div>
                )
              }
            })
          }
        </div>
        {
          cardInfo &&
            <div className='card-detail-enter-block'>
              {
                (cardInfo.card?.discountType || cardInfo.card?.mallDiscountType || cardInfo.card?.extra?.cardRightsDes || cardInfo.card?.isSendCoupon) &&
                  <div className='enter-item' onClick={() => showCardEquity('equity')}>
                    <span>{i18n.t('mkt.member.memberDiscountBenefits')}</span>
                    <i className='iconfont icon-chevron-right'></i>
                  </div>
              }
              {
                cardInfo.card?.isIntegral &&
                  <div className='enter-item' onClick={() => showCardEquity('integral')}>
                    <span>{i18n.t('cart.integralRule')}</span>
                    <i className='iconfont icon-chevron-right'></i>
                  </div>
              }
              <div className='enter-item' onClick={() => showCardEquity('recharge')}>
                <span>{i18n.t('mkt.member.rechargeDes')}</span>
                <i className='iconfont icon-chevron-right'></i>
              </div>
              <div className='enter-item' onClick={() => showCardEquity('store')}>
                <span>{i18n.t('mkt.member.applyStore')}</span>
                <i className='iconfont icon-chevron-right'></i>
              </div>
            </div>
        }
      </IonContent>
      {
        cardInfo &&
          <IonFooter>
            <div className='page-footer-block'>
              {
                clause?.clauseName && <div className='terms-info'><TermsTick terms={clause} isCheck={isAgree} showTip={showTip} onChange={(check: boolean) => changeTermsStatus(check)} /></div>
              }
            </div>
          </IonFooter>
      }
      {/* 自定义金额 */}
      <MktAmountBoard
        visible={showAmountModal}
        min={cardInfo && cardInfo.card?.minLoad}
        max={cardInfo && cardInfo.card?.maxLoad}
        onClose={() => setShowAmountModal(false)}
        onSave={(val: number) => changeCustom(val)}
      >
      </MktAmountBoard>
      <DetailModal
        isOpen={showPopover} title={i18n.t('mkt.member.rechargeDes')} reject={() => {
          setShowPopover(false)
        }}
      >
        <div className='text'>{cardInfo && cardInfo.card?.extra ? cardInfo.card?.extra.cardRechargeDes : ''}</div>
      </DetailModal>
    </IonPage>
  )
}

export default observer(Recharge)
